import { RealTimeDataStore } from "@app/services/store/real-time-data-store";
import { WebStompEntitySubscriber } from "@app/services/webstomp/web-stomp-entity-subscriber.service";
import { Injectable, inject } from "@angular/core";
import { ResourceFactMappingPattern } from "@app/models/rest/resource-fact-mapping-pattern";
import { ResourceFactMappingPatternRestService } from "@app/services/hal/resource-fact-mapping-pattern-rest.service";
import { HateoasResourceService } from "@lagoshny/ngx-hateoas-client";

@Injectable({ providedIn: "root" })
export class ResourceFactMappingPatternStore extends RealTimeDataStore<ResourceFactMappingPattern> {
  constructor() {
    const resourceFactMappingPatternRestService = inject(
      ResourceFactMappingPatternRestService
    );
    const webStompSubscriber = inject(WebStompEntitySubscriber);
    const hateoasResourceService = inject(HateoasResourceService);

    super(
      resourceFactMappingPatternRestService,
      webStompSubscriber,
      hateoasResourceService
    );
    super.subscribeToMessaging("ResourceFactMappingPattern");
  }
}
